import * as React from 'react';
import ViewHeaderBar from '../components/ViewHeaderBar';
import { localizations } from '../localization/localization';
import FeedbackBlock from './components/FeedbackBlock';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import TablePagination from '@material-ui/core/TablePagination';
import { Theme, StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as FeedbackStore from './store/feedbackStore';
import { PagingFilter } from '../common/models/PagingModels';

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    feedback: {
        marginBottom: theme.spacing(1),
    }
})

type WithStylesProps = "feedback";

type FeedbackViewState = PagingFilter;

type FeedbackViewProps = typeof FeedbackStore.actionCreators & FeedbackStore.FeedbackState & WithStyles<WithStylesProps>;

class FeedbackView extends React.Component<FeedbackViewProps, FeedbackViewState> {

    constructor(props: FeedbackViewProps) {
        super(props);

        this.state = {
            currentPage: 0,
            rowsPerPage: 10
        }

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRowPerPageChange = this.handleRowPerPageChange.bind(this);
        this.handleSetRead = this.handleSetRead.bind(this);
    }

    public componentDidMount() {
        this.props.requestFeedback(this.state);
    }

    public render() {
        const { isLoading, data, classes } = this.props;
        const currentPage = this.props.data ? this.props.data.currentPage : 0;
        const { rowsPerPage } = this.state;
        const rowCount = data ? data.rowCount : 0;

        return <div>
            <ViewHeaderBar title={localizations.admin.feedbackTitle} />
            <Grid container>
                {isLoading && !data ? <CircularProgress /> : data != null ? data.results.map((fb, index) => (<Grid key={index} item xs={12} className={classes.feedback}><FeedbackBlock setRead={() => this.handleSetRead(fb.id)} {...fb} /></Grid>)) : null}
            </Grid>

            <TablePagination count={rowCount} page={currentPage} rowsPerPage={rowsPerPage} onChangePage={this.handlePageChange} onChangeRowsPerPage={this.handleRowPerPageChange} labelRowsPerPage="Rivejä sivulla" />
        </div>
    }

    private handleSetRead(feedbackId: string) {
        this.props.setRead(feedbackId, this.state);
    }

    private handlePageChange(e: any, page: number) {
        const newState = Object.assign({}, this.state, { currentPage: page });

        this.setState(newState);
        this.props.requestFeedback(newState);
    }

    private handleRowPerPageChange(e: any) {
        const newState = Object.assign({}, this.state, { rowsPerPage: e.target.value });

        this.setState(newState);
        this.props.requestFeedback(newState);
    }
}

export default withStyles(styles)(connect((state: ApplicationState) => state.feedback, FeedbackStore.actionCreators)(FeedbackView));


// WEBPACK FOOTER //
// ./src/admin/FeedbackView.tsx